const data = {
    id : {
        title    : "Hubungi Kami",
        subTitle : "WASD Labs adalah developer software, website, aplikasi mobile, VR, AR, 3D Modeling, IoT, Jasa Drone dengan pengalaman lebih dari 5 tahun. Siap menyediakan solusi untuk rencana IT anda."
    }
}

export default data;